<div class="wrapper">
	<img src="assets/images/priority/{{ priority | lowercase }}.svg"/>
</div>